/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { apiResponseV4Schema } from './apiResponseV4Schema'
import { loginRequestV4Schema } from './loginRequestV4Schema'
import { loginResponseV4ApiResponseObjectV4Schema } from './loginResponseV4ApiResponseObjectV4Schema'

export const authLoginStatus200Schema = loginResponseV4ApiResponseObjectV4Schema.describe(
  'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
)

export const authLoginStatus400Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const authLoginResponseSchema = authLoginStatus200Schema

export const authLoginErrorSchema = authLoginStatus400Schema

export const authLoginBodySchemaJsonPatchJson = loginRequestV4Schema.optional()

export const authLoginBodySchemaJson = loginRequestV4Schema.optional()

export const authLoginBodySchemaJson2 = loginRequestV4Schema.optional()

export const authLoginBodySchemaJson3 = loginRequestV4Schema.optional()

export const authLoginBodySchema = z.union([
  authLoginBodySchemaJsonPatchJson,
  authLoginBodySchemaJson,
  authLoginBodySchemaJson2,
  authLoginBodySchemaJson3,
])
